/*
  This file abstracts away the specific network request tech and config that we're using.
  This keeps all API calls short and consistent.

  Opinions built in:
  1. Use Axios.
  2. Enforce convention for mapping environments to baseUrls.
  3. Make each API call concise by only exposing get, put, post, patch, del.
  4. Automatically sniff the environment via the app baseUrl provided for each env, and set the baseUrl for each API call accordingly.
  5. Fail fast and explicitly if a config is missing for an environment.
  6. Send credentials by default.
  7. Send and receive JSON by default.
*/
var axios = require('axios');
var utils = require('./utils');

function mergeConfig(config1, config2) {
  return Object.assign({}, config1, config2);
}

/*
  This factory function returns a config object.
  See README.md for an example.
*/
function axiosWrapper(config) {
  if (!config.baseUrls) {
    throw new Error('A map of baseUrls for each environment is required.');
  }

  var baseUrl =
    location.protocol +
    '//' +
    location.hostname +
    (location.port ? ':' + location.port : '');
  var env = utils.getEnvironment(baseUrl, config.baseUrls);

  var defaultConfig = {
    baseURL: utils.getApiBaseUrl(env, config.baseUrls),
    responseType: 'json',
    withCredentials: true
  };

  var mergedConfig = mergeConfig(defaultConfig, config);
  var api = axios.create(mergedConfig);

  // Return public functions
  // The config param is optional on all.
  return {
    get: function(url, config) {
      return config
        ? axios.create(mergeConfig(mergedConfig, config)).get(url)
        : api.get(url);
    },
    post: function(url, data, config) {
      return config
        ? axios.create(mergeConfig(mergedConfig, config)).post(url, data)
        : api.post(url, data);
    },
    put: function(url, data, config) {
      return config
        ? axios.create(mergeConfig(mergedConfig, config)).put(url, data)
        : api.put(url, data);
    },
    patch: function(url, data, config) {
      return config
        ? axios.create(mergeConfig(mergedConfig, config)).patch(url, data)
        : api.patch(url, data);
    },
    del: function(url, data, config) {
      return config
        ? axios.create(mergeConfig(mergedConfig, config)).delete(url, data)
        : api.delete(url, data);
    }
  };
}

module.exports = axiosWrapper;



//////////////////
// WEBPACK FOOTER
// ../fusion-http/index.js
// module id = 235
// module chunks = 2